import { render, staticRenderFns } from "./SetPhone.vue?vue&type=template&id=5d84ad80&scoped=true&"
import script from "./SetPhone.vue?vue&type=script&lang=js&"
export * from "./SetPhone.vue?vue&type=script&lang=js&"
import style0 from "./SetPhone.vue?vue&type=style&index=0&id=5d84ad80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84ad80",
  null
  
)

export default component.exports